export default "__VITE_ASSET__DwYIU$Sf__"